loadRoot("./");
loadSprite("nublin", "/sprites/pets/nublin.png");
loadSprite("werm", "/sprites/pets/werm.png");
loadSprite("eye", "/sprites/pets/eye.png");
loadSprite("bg_day", "/sprites/backgrounds/morning_bg.png");
loadSprite("button_feed", "/sprites/buttons/button_feed.png");
loadSprite("button_feed_pressed", "/sprites/buttons/button_feed_pushed.png");
loadSprite("button_kill", "/sprites/buttons/button_kill.png");
loadSprite("button_kill_pressed", "/sprites/buttons/button_kill_pushed.png");
loadSprite("button_play", "/sprites/buttons/button_play.png");
loadSprite("button_play_pressed", "/sprites/buttons/button_play_pushed.png");
loadSprite("button_shop", "/sprites/buttons/button_shop.png");
loadSprite("button_shop_pressed", "/sprites/buttons/button_shop_pushed.png");
loadSprite("apple", "/sprites/objects/apple.png");
loadSprite("grave", "/sprites/objects/grave.png");
loadSprite("poop", "/sprites/objects/poop.png");
loadSprite("poison", "/sprites/particles/effect_poison.png");
loadSprite("flame", "/sprites/particles/effect_flame.png");
loadSprite("heart", "/sprites/particles/effect_heart.png");
loadSprite("enemy", "/sprites/objects/enemy.png");
loadSprite("enemy2", "/sprites/objects/enemy2.png");
loadSprite("bg_night", "/sprites/backgrounds/night_bg.png");
loadSprite("sword", "/sprites/objects/sword.png");
loadSprite("hit", "/sprites/particles/effect_hit.png");
loadSprite("ammo", "/sprites/objects/ammo_icon.png");
loadSprite("wizard", "/sprites/wizard.png");
loadSprite("button_exit", "/sprites/buttons/button_exit.png");
loadSprite("button_exit_pushed", "/sprites/buttons/button_exit_pushed.png");
loadSprite("guy", "/sprites/craig-logo.png");

loadSound("beep", "/sounds/beep.mp3");
loadSound("click", "/sounds/click.mp3");
loadSound("eat", "/sounds/eat.mp3");
loadSound("meow", "/sounds/meow.wav");
loadSound("bong", "/sounds/bell.mp3");
loadSound("fart", "/sounds/fart.mp3");
loadSound("bullet", "/sounds/bullet.wav");
loadSound("reload", "/sounds/reload.mp3");
loadSound("night_song", "/sounds/skeleton_song.mp3");
loadSound("hurt", "/sounds/snd_hurt1.wav");
loadSound("punch", "/sounds/punch.wav");
loadSound("bell", "/sounds/snd_bell.wav");
loadSound("warning", "/sounds/warning.mp3");
loadSound("combo1", "/sounds/combo1.mp3");
loadSound("combo2", "/sounds/combo2.mp3");
loadSound("combo3", "/sounds/combo3.mp3");
loadSound("combo4", "/sounds/combo4.mp3");
loadSound("combo5", "/sounds/combo5.mp3");
loadSound("empty", "/sounds/empty.mp3");
loadSound("dash", "/sounds/snd_bombsplosion.wav");
loadSound("buy", "/sounds/buy.wav");
